@if (loading()) {
    <div class="absolute inset-0 z-20 flex justify-center items-center bg-white/60 rounded-md">
        <mat-spinner [diameter]="48"></mat-spinner>
    </div>
}

<mat-vertical-stepper class="border-gray-300 border-2 rounded-md" [class.border-red-500]="error()" [linear]="false"
    animationDuration="200" (selectionChange)="onStepChange($event)">
    <mat-step>
        <ng-template matStepLabel>Filteri</ng-template>

        <mat-checkbox
            (change)="filterEdpData.set($event.checked)"
            labelPosition="after">
            Međusobno isključivanje prema zaposlenicima
        </mat-checkbox>

        @if (!filtering()) {
            <div class="flex flex-wrap justify-start items-center gap-2 my-4 p-2">
                @for (group of value().filterGroups; track $index; let groupIdx = $index) {
                    <div class="flex flex-col space-y-2 relative p-2 border-2 border-gray-900/10 rounded-md min-w-[16rem] min-h-[8rem]">
                        @for (item of group | keyvalue; track $index; let filterIdx = $index) {
                            <div class="grid grid-flow-col gap-2 max-w-1/3">
                                @if (!filtering() && item.key === "orgUnits" && item.value !== null) {
                                    <div class="max-h-[10rem] overflow-y-auto p-4 border-2 border-gray-900/10 rounded-md">
                                        <div class="text-lg font-semibold my-1 whitespace-nowrap">Organizacijske jedinice</div>
                                        @for (name of item.value | edpDataNames:orgUnitsNames; track $index) {
                                            <p class="whitespace-nowrap">{{ name }}</p>
                                        }
                                    </div>
                                }
                                @else if (!filtering() && item.key === "positions" && !!item.value) {
                                    <div class="max-h-[10rem] overflow-y-scroll p-4 border-2 border-gray-900/10 rounded-md">
                                        <div class="text-lg font-semibold my-1 whitespace-nowrap">Pozicije</div>
                                        @for (name of item.value | edpDataNames:positionsNames; track $index) {
                                            <p class="whitespace-nowrap">{{ name }}</p>
                                        }
                                    </div>
                                }
                                @else if (!filtering() && item.key === "costCenters" && !!item.value) {
                                    <div class="max-h-[10rem] overflow-y-scroll p-4 border-2 border-gray-900/10 rounded-md">
                                        <div class="text-lg font-semibold my-1 whitespace-nowrap">Mjesto troška</div>
                                        @for (name of item.value | edpDataNames:costCentersNames; track $index) {
                                            <p class="whitespace-nowrap">{{ name }}</p>
                                        }
                                    </div>
                                }
                                @else if (!filtering() && item.key === "employeeTypes" && !!item.value) {
                                    <div class="max-h-[10rem] overflow-y-scroll p-4 border-2 border-gray-900/10 rounded-md">
                                        <div class="text-lg font-semibold my-1 whitespace-nowrap">Tip odnosa</div>
                                        @for (name of item.value | edpDataNames:employeeTypesNames; track $index) {
                                            <p class="whitespace-nowrap">{{ name }}</p>
                                        }
                                    </div>
                                }
                                @else if (!filtering() && item.key === "genders" && !!item.value) {
                                    <div class="max-h-[10rem] overflow-y-scroll p-4 border-2 border-gray-900/10 rounded-md">
                                        <div class="text-lg font-semibold my-1 whitespace-nowrap">Spol</div>
                                        @for (name of item.value | edpDataNames:gendersNames; track $index) {
                                            <p class="whitespace-nowrap">{{ name }}</p>
                                        }
                                    </div>
                                }

                                @if (!filtering() && item.value !== null) {
                                    <div class="space-y-2">
                                        <div><button mat-flat-button (click)="editFilter(item.key, groupIdx)">Uredi</button></div>
                                        <div><button mat-flat-button (click)="removeFilter(item.key, groupIdx)">X</button></div>
                                    </div>
                                }
                            </div>
                        }

                        <button mat-flat-button [matMenuTriggerFor]="menu">Odaberi filter</button>
                        <mat-menu #menu="matMenu">
                            @let activeGroup = value().filterGroups[activeGroupIdx];

                            @if (!activeGroup || (activeGroup && !activeGroup['orgUnits'])) {
                                <button (click)="addFilter('orgUnits', groupIdx)" mat-menu-item>Organizacijske jedinice</button>
                            }
                            @if (!activeGroup || (activeGroup && !activeGroup['positions'])) {
                                <button (click)="addFilter('positions', groupIdx)" mat-menu-item>Pozicije</button>
                            }
                            @if (!activeGroup || (activeGroup && !activeGroup['costCenters'])) {
                                <button (click)="addFilter('costCenters', groupIdx)" mat-menu-item>Mjesto troška</button>
                            }
                            @if (!activeGroup || (activeGroup && !activeGroup['employeeTypes'])) {
                                <button (click)="addFilter('employeeTypes', groupIdx)" mat-menu-item>Tip odnosa</button>
                            }
                            @if (!activeGroup || (activeGroup && !activeGroup['genders'])) {
                                <button (click)="addFilter('genders', groupIdx)" mat-menu-item>Spol</button>
                            }
                        </mat-menu>
                        <button mat-flat-button (click)="deleteFilterGroup(groupIdx)">Obriši grupu filtera</button>
                    </div>
                }
                <button mat-flat-button (click)="addFilterGroup()">Dodaj novu grupu filtera</button>
            </div>
        } @else {
            <div class="flex justify-end gap-4">
                <button class="w-fit" mat-flat-button (click)="discardFilter()">Poništi</button>
                <button class="w-fit" mat-flat-button (click)="saveFilter()">Spremi</button>
            </div>
            <div class="mt-2 grid grid-cols-[0.6fr_0.4fr] grid-flow-col gap-2 items-stretch h-[34rem]">
                <div class="flex flex-col min-h-0">
                    @if (filtering() === "positions") {
                        <valben-tree-filter
                            class="flex-1 min-h-0"
                            [values]="filteredDependencies().positions"
                            [labelAccessor]="getPositionLabel"
                            [idAccessor]="getPositionId"
                            [(selected)]="selected" />
                    }
                    @else if (filtering() === "orgUnits") {
                        <mat-radio-group [value]="orgUnitType()" (change)="orgUnitType.set($event.value)">
                            <mat-radio-button value="all">Sve</mat-radio-button>
                            <mat-radio-button value="cs">Centralne službe</mat-radio-button>
                            <mat-radio-button value="ops">Operacije</mat-radio-button>
                        </mat-radio-group>
                        <valben-tree-filter
                            class="flex-1 min-h-0"
                            [values]="filteredDependencies().orgUnits | orgUnitTree:orgUnitType()"
                            [labelAccessor]="getOrgUnitLabel"
                            [idAccessor]="getOrgUnitId"
                            [threeStateCheckbox]="true"
                            [(selected)]="selected" />
                    }
                    @else if (filtering() === "employeeTypes") {
                        <valben-tree-filter
                            class="flex-1 min-h-0"
                            [values]="dependencies().employeeTypes ?? []"
                            [labelAccessor]="getEmployeeTypeLabel"
                            [idAccessor]="getEmployeeTypeId"
                            [(selected)]="selected" />
                    }
                    @else if (filtering() === "genders") {
                        <mat-radio-group
                            [value]="selected()[0]"
                            (change)="selected.set([$event.value])"
                            class="flex flex-col">
                            <mat-radio-button value="M">Muško</mat-radio-button>
                            <mat-radio-button value="Z">Žensko</mat-radio-button>
                        </mat-radio-group>
                    }
                    @else if (filtering() === "costCenters") {
                        <valben-cost-centers-filter
                            [values]="filteredDependencies().costCenters"
                            [(selected)]="selected" />
                    }
                </div>
                <div class="flex flex-col min-h-0">
                    @if (uncovered() > 0) {
                        <p class="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-md p-2 mb-2">
                            {{ uncovered() }} zaposlenika nema nijednu od ponuđenih šifri i ne može biti obuhvaćeno ovim filtrom,
                            ni kad je označeno sve.
                        </p>
                    }
                    <mat-form-field>
                        <input
                            #empSearch
                            matInput
                            placeholder="Pretraži"
                            [value]="employeeSearch()"
                            (input)="employeeSearch.set(empSearch.value.toLowerCase())" />
                    </mat-form-field>
                    <cdk-virtual-scroll-viewport itemSize="48" class="flex-1 min-h-0">
                        <div *cdkVirtualFor="let e of filteredEmployees()" class="h-[48px]">
                            {{ e.fullName }} ({{ e.mbrad }})
                        </div>
                    </cdk-virtual-scroll-viewport>
                </div>
            </div>
        }
    </mat-step>

    <mat-step>
        <ng-template matStepLabel>Uključi/Isključi pojedince</ng-template>
        <valben-employees-pick-list
            #pickList
            [values]="pickEmployees()"
            (selected)="onEmit($event)" />
    </mat-step>

</mat-vertical-stepper>
